import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { disableRefreshToken } from "src/_Globals/queryClient/queryClient";
import { createEmptyMenuTreeResponse, MenuTreeResponse, MenuTreeNode } from "./useNavigationMenu";
import { parseMenuTreeResponse } from "./parseMenuTreeResponse";

export type { MenuTreeNode };

export const getFooterMenuQueryKey = "getFooterMenu" as const;

export const useFooterMenu = (organizationId: number | undefined) => {
    const query = useQuery({
        queryKey: [getFooterMenuQueryKey, organizationId],
        meta: {
            [disableRefreshToken]: true,
        },
        queryFn: async (): Promise<MenuTreeResponse> => {
            if (organizationId === undefined) {
                return createEmptyMenuTreeResponse();
            }

            const response = await loggedInApiCall.get(`/api/organizations/${organizationId}/menus/footer/tree`);

            return parseMenuTreeResponse(response.data);
        },
        enabled: organizationId !== undefined,
        staleTime: 30000,
        cacheTime: 300000,
    });

    return {
        menuTree: query.data?.tree || [],
        meta: query.data?.meta || { total_items: 0, max_depth: 0, last_updated: new Date().toISOString() },
        isLoading: query.isLoading,
        error: query.error,
        refetch: query.refetch,
    };
};
